import { render } from "./SecurityLog.vue?vue&type=template&id=f15280fc&scoped=true"
import script from "./SecurityLog.vue?vue&type=script&lang=js"
export * from "./SecurityLog.vue?vue&type=script&lang=js"

import "./SecurityLog.vue?vue&type=style&index=0&id=f15280fc&scoped=true&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f15280fc"]])

export default __exports__